import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { Button, Grid } from '@mui/material';
import { useCallback, useContext, useEffect, useReducer, useState } from 'react';
import { isDeviceEnabledType } from '@iotv/payload-definition';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { getNodeEdgeMapperReducer } from '../../ContextProviders/NodeEdgeMapperComponentContext';
import { useThemedMap } from '../../GoogleMapV4/useThemedMap';
import { extractGeoDataFromViewObject } from '../../util/geo/GeoDataHelpers';
import { DeviceLinkContext } from './DeviceLinkContext';
const COMPONENT_WIDTH = '350px';
const COMPONENT_HEIGHT = '400px';
const CurrentLocationMap = () => {
    const [{ contextProperty, TransactionFunctions, isSmallView }] = useContext(AppMainViewContext);
    const { updateLocation, entityList, location, areaList } = useContext(DeviceLinkContext);
    const [view, setView] = useState(false);
    useEffect(() => {
        dispatch({ type: 'clearNEMContents', value: null });
        const timer = setTimeout(async () => {
            let joined = [...entityList, ...areaList];
            if (location) {
                const locationObj = {
                    type: 'Point',
                    name: 'Current Location',
                    sk: 'Point',
                    id: 'Point',
                    location,
                    points: [location],
                    pk: 'Point',
                };
                joined = [...joined, locationObj];
            }
            dispatch({ type: 'loadItems', value: { items: joined } });
        }, 500);
        return () => {
            clearTimeout(timer);
        };
    }, [contextProperty, location, entityList, areaList]);
    const nodeEdgeReducer = getNodeEdgeMapperReducer({ canaryString: 'CurrentLocationMap' });
    const [state, dispatch] = useReducer(nodeEdgeReducer, {
        nodeEdgeMapper: new NodeEdgeMapper(),
        nemHash: null,
        apexNode: null,
    });
    const { thingStatesMostRecentFirst, } = isDeviceEnabledType(contextProperty)
        ? extractGeoDataFromViewObject({
            matchedPrimary: contextProperty,
            matchedRelatedByPk: undefined,
            matchedRelatedBySk: undefined,
        })
        : {
            mapViewObject: undefined,
            lastestThingStateShadow: undefined,
            track: [],
            position: undefined,
            thingStatesMostRecentFirst: [],
        };
    const getUseThemedMapInput = useCallback(() => {
        const res = {
            canaryString: 'CurrentLocationMap',
            contextObject: contextProperty,
            nodeEdgeMapper: state.nodeEdgeMapper,
            nodeEdgeMapperDispatch: dispatch,
            transactionFunctions: TransactionFunctions,
            options: {
                tilt: 0, // show facedown view that stops 'cannot be found' error on zoom-in
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_RIGHT,
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP], // Restrict to ROADMAP only
                },
                fullscreenControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoom: 25,
                center: { lat: location.lat, lng: location.lng }, //location is checked before this component
                clickableIcons: false,
                controlSize: 25,
            },
            dataFn: (async (gob) => {
                return { ...gob, data: {} };
            }),
            functions: {},
            showDrawingTools: false,
            themesAndLabels: {},
            areaData: [],
            lineDefiningPairs: [],
        };
        return res;
    }, [state, contextProperty]);
    const { map, components: { PortalDiv }, state: stateWithData, } = useThemedMap(getUseThemedMapInput());
    const gmap = stateWithData.map;
    useEffect(() => {
        const timer = setTimeout(async () => {
            if (location) {
                if (gmap) {
                    gmap.panTo(location);
                    gmap.setZoom(25);
                }
            }
        }, 1500);
        return () => {
            clearTimeout(timer);
        };
    }, [location, gmap]);
    return updateLocation || location ? (_jsx("div", { style: {
            containerType: 'size',
            width: '100%',
            height: view ? COMPONENT_HEIGHT : isSmallView ? '50px' : '100%',
        }, children: view ? (_jsx(Grid, { container: true, children: _jsx(Grid, { size: { xs: 12 }, sx: { height: isSmallView ? COMPONENT_WIDTH : '80vh' }, children: _jsxs(_Fragment, { children: [PortalDiv, map.current] }) }) })) : (_jsx(Button, { fullWidth: true, variant: "contained", onClick: () => setView(true), children: "Press To View Map" })) })) : (_jsx(_Fragment, {}));
};
export default CurrentLocationMap;
